import api from "../config/api";

const jatsaPeticionService = {
  async listar(empresaId) {
    const response = await api.get("/jatsa-peticiones", {
      params: { empresa_id: empresaId },
    });
    return response.data;
  },

  async marcarLeida(id) {
    const response = await api.put(`/jatsa-peticiones/${id}/leer`);
    return response.data;
  },

  async marcarTodasLeidas(empresaId) {
    const response = await api.put("/jatsa-peticiones/leer-todas", {
      empresa_id: empresaId,
    });
    return response.data;
  },
};

export default jatsaPeticionService;
